import Backend from "./Backend";
import {selectedCompanyStore} from "../store/SelectedCompany";
import {CustomerDto} from "../model/customer/Customer";

class CustomerApi {

    public fetchCustomers(): Promise<CustomerDto[]> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/parties/customer`);
    }

    public fetchCustomer(uuid: string): Promise<CustomerDto> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/parties/customer/${uuid}`);
    }

    public saveCustomer(customer: CustomerDto): Promise<CustomerDto> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.post(`/api/v1/company/${companyId}/parties/customer`, customer);
    }

}

export const customerApi = new CustomerApi();